import { Injectable } from '@angular/core';
import { IntegrationStatus, PicTimeClientInfo } from '@models/models';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class IntegrationsServiceProvider {
	successSavedGallery: BehaviorSubject<any> = new BehaviorSubject(false);

	constructor() {}

	get shouldGalleriesBeUpdatedObservable() {
		return this.successSavedGallery.asObservable();
	}

	emitGalleriesUpdateEvent(value) {
		return this.successSavedGallery.next(value);
	}

	destroyGalleriesUpdatedObservable(): void {
		this.successSavedGallery.next(false);
	}

	createTextForApplyConfirm(clients: Array<PicTimeClientInfo>): string {
		const [primaryClient, secondaryClient] = clients;
		if (secondaryClient) {
			return `Copy clients <strong>${primaryClient.name} (${
				primaryClient.email
			})</strong> and <strong>${secondaryClient.name} (${
				secondaryClient.email
			})</strong> to this gallery's Pic-Time Share settings? <br>
 			You will need to invite this client from Pic-Time so that they can view the gallery.`;
		}

		return `Copy client <strong>${primaryClient.name} (${
			primaryClient.email
		})</strong> to this gallery's Pic-Time Share settings? <br>
 			You will need to invite this client from Pic-Time so that they can view the gallery.`;
	}

	getXeroStatusText(status: string): IntegrationStatus {
		switch (status) {
			case 'COPIED_TO_XERO':
				return {
					text: 'COPIED TO XERO',
					cssClass: 'bg-sky color-white'
				};
			case 'FAILED_TO_COPY':
				return {
					text: 'FAILED TO COPY TO XERO',
					cssClass: 'bg-orange color-white'
				};
			case 'DISCONNECTED_XERO_INVOICE_ALTERED':
				return {
					text: 'DISCONNECTED - XERO INVOICE ALTERED',
					cssClass: 'bg-froly-dark color-white'
				};
			default:
				return {
					text: '',
					cssClass: ''
				};
		}
	}

	getQuickbooksStatusText(status): IntegrationStatus {
		switch (status) {
			case 'COPIED':
				return {
					text: 'COPIED TO QUICKBOOKS',
					cssClass: 'bg-green color-white'
				};
			case 'FAILED_TO_COPY':
				return {
					text: 'FAILED TO COPY TO QUICKBOOKS',
					cssClass: 'bg-orange color-white'
				};
			case 'DISCONNECTED_INVOICE_ALTERED':
				return {
					text: 'DISCONNECTED - QUICKBOOKS INVOICE ALTERED',
					cssClass: 'bg-froly-dark color-white'
				};
			default:
				return {
					text: '',
					cssClass: ''
				};
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/integrations/integrations.service.ts